<div class="d-flex gap-1">
    @if (hasErrorIconClickCallback) {
        <button
            type="button"
            class="btn btn-link text-danger p-0"
            (click)="errorIconClick($event)"
            fdxStopPropagation>
            <fa-icon [icon]="errorIcon" class="no-margin" size="sm"></fa-icon>
        </button>
    }
    <span
        [ngClass]="{ 'fst-italic': displayedValue === blankItem }"
        [title]="displayedValue"
        class="text-truncate text-break">{{ displayedValue }}</span>
    @if (shouldDisplayPathModal) {
        <button
            type="button"
            class="btn btn-link text-secondary p-0"
            (click)="openPathModal()"
            title="Open corresponding paths"
            fdxStopPropagation>
            <fa-icon [icon]="pathIcon" class="no-margin" size="sm"></fa-icon>
        </button>
    }
</div>
@if (shouldDisplayPathInline) {
    <div class="fdx-category-path text-truncate text-break" [title]="displayedPath">{{ displayedPath }}</div>
}
